import './index.css'
import cn from 'clsx'
import * as React from 'react'
import TagMenu from 'components/explorer/tag-menu'
import Button from 'components/ui/button'
import Tag from 'components/ui/tag'
type Props = {
  tags: string[]
  partiallySelectedTags?: string[] | null | undefined
  onTagRemove?: (...args: Array<any>) => any
  onTagClick?: (...args: Array<any>) => any
  onTagAdd?: (...args: Array<any>) => any
  tagType: 'playlist' | 'contact'
  type: 'expanding' | 'fixed'
  preventMenuClose?: boolean
  emptyPlaceholder?: React.ReactNode
  displaySelectedTagsInMenu?: boolean
}
type State = {
  isShowMore: boolean
  tagMenuOpen: boolean
  tagMenuPosition: ClientRect | null | undefined
}

class TagList extends React.Component<Props, State> {
  static defaultProps: {
    tagType: 'playlist' | 'contact'
    type: 'expanding' | 'fixed'
  } = {
    tagType: 'playlist',
    type: 'expanding',
  }
  state: State = {
    tagMenuOpen: false,
    tagMenuPosition: null,
    isShowMore: false,
  }
  _tagAdd: HTMLDivElement | null | undefined
  _tagMenuSwitch: () => void = () => {
    this.setState({
      tagMenuOpen: !this.state.tagMenuOpen,
      tagMenuPosition:
        !this.state.tagMenuOpen && this.props.onTagAdd && this._tagAdd
          ? this._tagAdd.getBoundingClientRect()
          : this.state.tagMenuPosition,
    })
  }
  _onTagSelect: (tag: string) => void = (tag: string) => {
    const { tags, tagType, onTagRemove, onTagAdd, partiallySelectedTags } =
      this.props
    if (!onTagRemove || !onTagAdd) return
    if (tagType === 'contact' && tag.toLowerCase() === 'business') return

    if (
      tags.includes(tag) &&
      (!partiallySelectedTags || !partiallySelectedTags.includes(tag))
    ) {
      onTagRemove(tag)
    } else {
      onTagAdd(tag)
    }
  }

  render(): React.ReactElement<'div'> {
    const {
      tags,
      onTagClick,
      onTagRemove,
      onTagAdd,
      emptyPlaceholder,
      tagType,
      preventMenuClose,
      displaySelectedTagsInMenu,
      partiallySelectedTags,
    } = this.props
    const filteredTags = partiallySelectedTags
      ? tags.filter(t => !partiallySelectedTags.includes(t))
      : tags
    const tagAdd = onTagAdd ? (
      <div
        ref={r => {
          this._tagAdd = r
        }}
      >
        <Button
          appearance="icon"
          icon="auto-tag"
          tooltip={
            tagType === 'contact' ? 'Add contact tags' : 'Add playlist tags'
          }
          onClick={this._tagMenuSwitch}
        />
        {this.state.tagMenuOpen && (
          <TagMenu
            tagType={tagType}
            position={this.state.tagMenuPosition}
            onClose={this._tagMenuSwitch}
            onSelect={this._onTagSelect}
            selectedTags={filteredTags}
            partiallySelectedTags={partiallySelectedTags}
            allowCreate
            preventMenuClose={preventMenuClose}
            displaySelectedTags={displaySelectedTagsInMenu}
          />
        )}
      </div>
    ) : null
    const tagList = tags.map((tag, index) => {
      const tagCanBeRemoved =
        tagType !== 'contact' || tag.toLowerCase() !== 'business'

      const removeTag = () => {
        if (onTagRemove) {
          onTagRemove(tag)
        }
      }

      return (
        <span className="tag-list-item" key={index}>
          <Tag
            tag={tag}
            onTagClick={onTagClick}
            onRemoveClick={tagCanBeRemoved ? removeTag : undefined}
          />
        </span>
      )
    })
    const isEmpty = tags.length === 0
    const truncated = tagList.length > 6
    return (
      <div
        className={cn('tag-list', {
          'tag-list--fixed': this.props.type === 'fixed',
        })}
        onClick={isEmpty ? this._tagMenuSwitch : null}
      >
        {isEmpty && emptyPlaceholder ? (
          emptyPlaceholder
        ) : (
          <div
            className={cn('tag-list__tags', {
              'tag-list__tags--full-width': !tagAdd,
            })}
          >
            {!truncated || this.state.isShowMore
              ? tagList
              : tagList.slice(0, 5)}
            {truncated && (
              <div
                className="tag__more"
                onClick={() => {
                  this.setState({
                    isShowMore: !this.state.isShowMore,
                  })
                }}
              >
                {this.state.isShowMore ? (
                  <span>Show less</span>
                ) : (
                  <span>Show more</span>
                )}
              </div>
            )}
          </div>
        )}
        {tagAdd && <div className="tag-list__button">{tagAdd}</div>}
      </div>
    )
  }
}

export default TagList
